module.exports = __webpack_public_path__ + "img/44.85c30334.png";